<script setup lang="ts">
import { ref } from 'vue';
import { ArrowRight, Sparkles, X } from '@lucide/vue';

const visible = ref(true);
</script>

<template>
    <div
        v-if="visible"
        class="border-primary/20 bg-primary/10 relative border-b"
    >
        <div
            class="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 py-2 pr-12 text-sm sm:px-6 lg:px-8"
        >
            <Sparkles
                class="text-primary hidden size-4 sm:block"
                aria-hidden="true"
            />
            <p>
                <span class="font-medium"
                    >LaunchStation is in early access.</span
                >
                <span class="text-muted-foreground hidden sm:inline">
                    Your AI marketing assistant is being built now.
                </span>
            </p>
            <a
                href="#early-access"
                class="text-foreground inline-flex items-center gap-1 font-medium underline underline-offset-4"
            >
                Join early access
                <ArrowRight class="size-3.5" aria-hidden="true" />
            </a>
        </div>
        <button
            type="button"
            class="hover:bg-primary/15 absolute top-1/2 right-2 -translate-y-1/2 rounded-md p-1.5"
            @click="visible = false"
        >
            <X class="size-4" aria-hidden="true" />
            <span class="sr-only">Dismiss announcement</span>
        </button>
    </div>
</template>
